import { SET_STOPWATCH_TIME } from '../actionTypes';

const initialState = {
    timer: {
        sec: 0,
        min: 0,
        hr: 0
    },
};

const StopWatchReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_STOPWATCH_TIME:
            return {
                ...state, timer: action.payload
            };
        default:
            break;
    }

    return state;
};

export default StopWatchReducer;
